<template>
  <v-app>
    <v-tabs v-model="activeTab" class="custom-tabs">
      <v-tab v-for="tab in tabs" :key="tab.name">
        {{ serverTranslate(tab.name) }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="tab in tabs" :key="tab.name">
        <component :is="tab.component" :tab-name="tab.name"></component>
      </v-tab-item>
    </v-tabs-items>
  </v-app>
</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.ts";
import globalMethodsMixin from "@/mixins/serverTranslations";
import ApplicationFeeRule from './ApplicationFeeRule.vue'
import AdmissionRules from './CertMinTotalRule.vue'
import GeneralAdmissionRules from './GeneralAdmissionRules.vue'
import CertPreQualRules from "./CertPrequalRules.vue"
import FeesDesiresRules from "./FeesDesiresRules.vue"

export default {
  name: 'Tabs',
  mixins: [serverTranslationsMixin, globalMethodsMixin],
  components: {
    GeneralAdmissionRules,
    CertPreQualRules,
    FeesDesiresRules,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [

        {name: this.$t("ADMISSION_CERTIFICATE_PREQUAL_RULES"), component: 'CertPreQualRules'},
        {name: this.$t("ADMISSION_DESIRES_FEES_RULES"), component: 'FeesDesiresRules'},
        {name: this.$t("GENERAL_ADMISSION_RULES"), component: 'GeneralAdmissionRules'},

      ]
    }
  }
}
</script>

<style scoped>

.custom-tabs {
  margin: 0;
  padding: 0;
  max-height: 50px;
}

</style>
  